// store.js

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import addUserReducer from "../reducer/AddUserReducer";
import authReducer from "../redux/features/authSlice";
import DriveMasterReducer from "../reducer/DriveMasterReducer";
import storage from "redux-persist/lib/storage";
import {
   persistStore,
   persistReducer,
   FLUSH,
   REHYDRATE,
   PAUSE,
   PERSIST,
   PURGE,
   REGISTER,
} from "redux-persist";
import listUserSlice from "./features/listUserSlice";
import fleetMasterReducer from "./features/fleetMaster";
import driverMasterReducer from "./features/driverMaster";
import customerMasterReducer from "./features/customerMaster";
import laneMasterReducer from "./features/laneMaster";
import helperReducer from "./features/helperSlice";
import helperMasterReducer from "./features/helperMaster";
import vendorMasterReducer from "./features/vendorMaster";
import contractorMasterAddSlice from "./features/contractor-master/contractorMasterAddSlice";
import contractorMasterListSlice from "./features/contractor-master/contractorMasterListSlice";
import singleContractorContactDetailsSlice from "./features/contractor-master/singleContractorContactDetailsSlice";
import contractorMasterReducer from "./features/contractorMasterSlice";
import adhocLaneReducer from "./features/adhocLaneSlice";
import tripReducer from "./features/tripSlice";

import adhocTripReducer from "./features/adhocTripSlice";

import createActualReducer from "./features/createActualSlice";

import companyMasterListSlice from "./features/company-master/companyMasterSlice";
import kiloleterMasterListSlice from "./features/kiloleter-master/kiloleterMasterSlice";
import tonnageMasterSlice from "./features/tonnage-master/tonnageSlice";
import categoryMasterSlice from "./features/vehicle-category/categoriesSlice";
import fleetMasterExpirationReducer from "./features/fleetMasterExpirationSlice";
import loadingReportMasterListSlice from "./features/report-master/loadingReportMasterSlice";
import vehicleShortageSummaryReportMasterSlice from "./features/report-master/vehicleShortageSummaryReportMasterSlice";
import tripExpensesSummaryReportMasterSlice from "./features/report-master/tripExpensesSummaryReportMasterSlice";
import performanceReportMasterSlice from "./features/report-master/performanceReportMasterSlice";
import monthlyLoadingGraphSlice from "./features/report-master/monthlyLoadingGraphSlice";
import reportDropDownRecordSlice from "./features/report-master/reportDropDownRecordSlice";

import currentOpenTripListSlice from "./features/dashboard-master/currentOpenTripSlice";
import unassignedTripVehiclesSlice from "./features/dashboard-master/unassignedTripVehiclesSlice";
import configReducer from "./features/configSlice";

const rootReducer = combineReducers({
   addUser: addUserReducer,
   listUser: listUserSlice,
   auth: authReducer,
   driveMaster: DriveMasterReducer,
   companyMasterListSlice: companyMasterListSlice,
   kiloleterMasterListSlice: kiloleterMasterListSlice,
   categoryMasterSlice:categoryMasterSlice,
   tonnageMasterSlice:tonnageMasterSlice,
   fleetMaster: fleetMasterReducer,
   fleetMasterExpiration: fleetMasterExpirationReducer,
   driverMaster: driverMasterReducer,
   customerMaster: customerMasterReducer,
   laneMaster: laneMasterReducer,
   helper: helperReducer,
   helperMaster: helperMasterReducer,
   vendorMaster: vendorMasterReducer,
   contractorMasterAddSlice: contractorMasterAddSlice,
   contractorMasterListSlice: contractorMasterListSlice,
   singlecontractorContactDetailsSlice: singleContractorContactDetailsSlice,
   contractorMaster: contractorMasterReducer,
   trip: tripReducer,
   adhocLane: adhocLaneReducer,

   adhocTrip: adhocTripReducer,

   createActual: createActualReducer,



   reportDropDownRecordSlice:reportDropDownRecordSlice,
   loadingReportMasterListSlice:loadingReportMasterListSlice,
   vehicleShortageSummaryReportMasterSlice:vehicleShortageSummaryReportMasterSlice,
   tripExpensesSummaryReportMasterSlice:tripExpensesSummaryReportMasterSlice,
   performanceReportMasterSlice:performanceReportMasterSlice,
   monthlyLoadingGraphSlice:monthlyLoadingGraphSlice,


   currentOpenTripList:currentOpenTripListSlice,
   unassignedTripVehiclesList:unassignedTripVehiclesSlice,
   config: configReducer,
});

const persistConfig = {
   key: "root",
   storage,
   blacklist: ["helper"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
   reducer: persistedReducer,
   middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
         serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
         },
      }),
});
export const persistor = persistStore(store);

export default store;
